module.exports = __webpack_public_path__ + "img/PMP.732a4442.png";